// @ts-check
import classNames from 'classnames';
import { graphql, useStaticQuery } from 'gatsby';
import React from 'react';
import { useContentStackProps } from '~/contentstack';
import SingleAlert from './SingleAlert';

import './Alerts.scss';

/**
 * @typedef AlertOptions
 * @property {string} uid
 * @property {import('./SingleAlert').SingleAlert[]} alerts
 *
 * @typedef AlertProps
 * @property {AlertOptions} [options]
 */
/** @type {import('~/types/React').ReactFC<AlertProps>} */
const Alerts = ({ options, ...rest }) => {
	/** @type {{ ozkAlertManager: AlertOptions }} */
	const { ozkAlertManager: staticModel } = useStaticQuery(graphql`
		query AlertManagerQuery {
			ozkAlertManager {
				uid
				_version
				title
				locale

				alerts {
					heading
					copy {
						json
					}
					include_warning_icon
					active_by
					expires_by
					click_destination {
						title
						href
					}
				}
			}
		}
	`);

	const [, model$] = useContentStackProps(
		{
			staticModel,
			contentType: 'alert_manager',
			contentUid: staticModel?.uid,
		},
		{ isOptional: true, fetchDynamicData: true }
	);

	return (
		<div {...rest} id="alert" className={classNames(rest.className, 'alerts fade-in-down')}>
			{model$?.alerts?.length > 0 &&
				model$?.alerts.map((singleAlert, i) => <SingleAlert alert={singleAlert} key={i} />)}
		</div>
	);
};

export default Alerts;
